$(document).ready(function () {
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $(".sticky-header").addClass("show");
    } else {
      $(".sticky-header").removeClass("show");
    }
  });

  checkElementPresence();
  function checkElementPresence() {
    const elem = document.querySelector(".wg-default");

    if (elem) {
      // console.log("Element is present");
      if (window.matchMedia("(max-width: 991px").matches) {
        setTimeout(() => {
          $("body > .wg-default").appendTo($(".site-menu-sidebar-footer "));
        }, 100);
      } else {
        setTimeout(() => {
          $("body > .wg-default").prependTo(
            $(".announcement-bar__localization-form ")
          );
        }, 100);
      }
    } else {
      // console.log("tst");
      setTimeout(checkElementPresence, 500);
    }
  }
});

$(document).ready(function () {
  if ($("body:not(.member-customer)").hasClass("template-product")) {
    checkLoginToBuy();
  }

  // checkElementPresence();
  function checkLoginToBuy() {
    const elem = document.querySelector(
      "a.mb-1.add-to-cart-btn.push-btn.theme-button.theme-button.w-full.block"
    );
    if (elem) {
      // console.log("Element is present");
      const setVariable = $(
        "a.mb-1.add-to-cart-btn.push-btn.theme-button.theme-button.w-full.block"
      ).attr("href");
      $(
        "a.mb-1.add-to-cart-btn.push-btn.theme-button.theme-button.w-full.block"
      ).removeAttr("href");

      $("body").on(
        "click",
        "a.mb-1.add-to-cart-btn.push-btn.theme-button.theme-button.w-full.block",
        function () {
          localStorage.setItem("afterLoginRedirectUrl", window.location.href);
          setTimeout(() => {
            if ($("body").hasClass("customer-logged-in")) {
              window.location = window.location.origin + "/pages/membership";
            } else {
              window.location = window.location.origin + setVariable;
            }
          }, 100);
        }
      );
    } else {
      // console.log("tst");
      setTimeout(checkLoginToBuy, 500);
    }
  }

  if ($("body").hasClass("template-customers-login")) {
    if (localStorage.getItem("afterLoginRedirectUrl")) {
      $('#customer_login input[name="return_to"]').attr(
        "value",
        localStorage.getItem("afterLoginRedirectUrl")
      );
    } else {
    }
  }
  if ($("body").hasClass("member-customer")) {
    setTimeout(() => {
      localStorage.removeItem("afterLoginRedirectUrl");
    }, 100);
  } else {
    localStorage.removeItem("afterLoginRedirectUrl");
  }
});
